<template>
  <b-sidebar
    id="element-sidebar"
    :visible="isToggleSidebarNormativa"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => toggleSidebar(val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ titleForm }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>
      <!-- Form -->
      <b-form
        class="p-2"
        @reset.prevent="resetForm"
      >

        <b-form-group
          label="Título"
          label-for="titulo"
        >
          <b-form-input
            id="titulo"
            v-model="dataRegister.titulo"
            autofocus
            trim
            placeholder=""
          />
        </b-form-group>

        <b-form-group
          label="Sumilla"
          label-for="sumisa"
        >
          <b-form-textarea
            id="sumisa"
            v-model="dataRegister.sumisa"
            rows="3"
            max-rows="8"
            class="mb-1 mb-xl-0"
          />
        </b-form-group>

        <b-form-group
          label="Orden"
          label-for="orden"
        >
          <b-form-input
            id="orden"
            v-model="dataRegister.orden"
            autofocus
            trim
            placeholder=""
            type="number"
          />
        </b-form-group>

        <h6
          class="text-info"
        >
          <feather-icon icon="FileIcon" />
          <span class="align-middle ml-25">Archivo</span>
        </h6>

        <hr style="border-top: 2px solid #00cfe8;margin-bottom: 1rem !important;margin-top: 0 !important;">

        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body mb-2">
            <feather-icon
              class="mr-25"
              icon="InfoIcon"
            />
            <span class="ml-25">Formato de archivo: PDF.</span>
          </div>
        </b-alert>

        <!-- Banner -->
        <b-form-group
          label=""
          label-for="banner"
        >
          <b-row class="container">
            <b-col md="4">
              <b-media-aside class="media-left mr-50">
                <b-avatar
                  rounded
                  size="70"
                  variant="light"
                  :src="dataRegister.archivo ? imgPdfActive : imgPdfInActive"
                />
              </b-media-aside>
            </b-col>
            <b-col md="8">
              <b-row class="mt-2">
                <b-col md="12">
                  <b-button
                    variant="info"
                    class="btn-block btn-sm"
                    @click="$refs.refInputElPdf.$el.click()"
                  >
                    <b-form-file
                      id="file"
                      ref="refInputElPdf"
                      v-model="filePdf"
                      accept=".pdf"
                      :hidden="true"
                      plain
                      @change="uploadPdf"
                    />
                    <span class="d-none d-sm-inline">{{ dataRegister.archivo ? 'Cambiar Archivo' : 'Seleccionar Archivo' }}</span>
                    <feather-icon
                      icon="EditIcon"
                      class="d-inline d-sm-none"
                    />
                  </b-button>
                </b-col>
              </b-row>
              <!-- <b-row style="padding-top:4px">
                <b-col md="12">
                  <b-button
                    variant="light"
                    class="btn-block btn-sm"
                    @click="onDeletePdf"
                  >
                    <span class="d-none d-sm-inline">Eliminar Archivo</span>
                    <feather-icon
                      icon="TrashIcon"
                      class="d-inline d-sm-none"
                    />
                  </b-button>
                </b-col>
              </b-row> -->
            </b-col>
          </b-row>
        </b-form-group>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="button"
            @click="saveForm"
          >
            Guardar
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-secondary"
            @click="hide"
          >
            Cancelar
          </b-button>
        </div>

      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BButton, BFormFile, BRow, BCol, BAvatar, BAlert,
  BMediaAside, BFormTextarea,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import store from '@/store'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormFile,
    BRow,
    BCol,
    BMediaAside,
    BAvatar,
    BAlert,
    BFormTextarea,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isToggleSidebarNormativa',
    event: 'update:is-toggle-sidebar-normativa',
  },
  props: {
    isToggleSidebarNormativa: {
      type: Boolean,
      required: true,
    },
    normativaSel: {
      type: Object,
      required: false,
      default: null,
    },
    dataEditNormativa: {
      type: Object,
      required: false,
      default: null,
    },
    formTypeNormativa: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
  setup(props, { emit }) {
    const titleForm = ref('')
    const dataRegister = ref({})
    const imgBase64Banner = ref(null)
    const refInputElPdf = ref(null)
    const filePdf = ref(null)
    const publicadoOpts = ref(['SI', 'NO'])
    const imgPdfActive = require('@/assets/images/erp/docs/pdf.png')
    const imgPdfInActive = require('@/assets/images/erp/docs/pdf-inactive.png')

    const onDeletePdf = () => {
      filePdf.value = null
    }
    const uploadPdf = e => {
      const fileTemp = e.target.files[0]
      filePdf.value = fileTemp
    }

    const resetForm = () => {
      dataRegister.value = {}
    }

    const saveForm = async () => {
      let service = 'portal/NORMATIVA_TRAMITE_CREATE'
      dataRegister.value.archivo = (filePdf.value !== null) ? filePdf.value : null
      dataRegister.value.idTramiteOrientacion = props.normativaSel.idTramiteOrientacion

      if (props.formTypeNormativa === 'edit') {
        service = 'portal/NORMATIVA_TRAMITE_UPDATE'
      }
      await store.dispatch(service, dataRegister.value)
        .then(response => {
          emit('refetch-data', response)
          emit('update:is-toggle-sidebar-normativa', false)
        })
        .catch(error => {
          emit('error-data', error)
          emit('update:is-toggle-sidebar-normativa', false)
        })
    }

    const toggleSidebar = val => {
      resetForm()
      emit('update:is-toggle-sidebar-normativa', val)
      if (props.formTypeNormativa === 'new') {
        titleForm.value = 'Agregar Normativa'
      }
      if (props.formTypeNormativa === 'edit') {
        dataRegister.value = props.dataEditNormativa
        titleForm.value = 'Editar Normativa'
      }
    }

    return {
      resetForm,
      dataRegister,
      saveForm,
      toggleSidebar,
      titleForm,
      onDeletePdf,
      uploadPdf,
      imgBase64Banner,
      refInputElPdf,
      filePdf,
      publicadoOpts,
      imgPdfActive,
      imgPdfInActive,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

#element-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}

.vs__selected-options {
  flex-wrap: nowrap;
  max-width: calc(100% - 41px);
}

.vs__selected {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  overflow: hidden;
}

.vs__search {
  position: absolute;
}

.vs--open .vs__search {
  position: static;
}

.vs__dropdown-option {
  white-space: normal;
}
</style>
